export default __webpack_public_path__ + "assets/images/Campaigns-d479b41c51e761db3405d0cd3232e900.svg";